import { numTicketsService } from 'store/services/num-tickets.service';
import { numTicketConstants } from 'store/constants';
import { alertsActions } from '.';
import getErrorMessage from 'utils/getErrorMessage';

const updateNumTicket = (data) => {
  return {
    type: numTicketConstants.NUMTICKET_SUCCESS,
    payload: { data },
  };
};
const getNumTickets = () => {
  const request = () => {
    return {
      type: numTicketConstants.NUMTICKET_REQUEST,
    };
  };
  const failure = (error) => {
    return {
      type: numTicketConstants.NUMTICKET_ERROR,
      payload: {
        error,
      },
    };
  };

  return async (dispatch) => {
    dispatch(request());
    try {
      const data = await numTicketsService.getNumTickets();
      dispatch(updateNumTicket(data));
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      dispatch(failure(errorMessage as string));
      dispatch(alertsActions.error(errorMessage));
    }
  };
};

export const numTicketsActions = {
  getNumTickets,
  updateNumTicket,
};
